<template>
  <div class="provider-info-list-input">
    <div v-if="title" class="title">{{ title }}</div>
    <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>
    <div class="mb-4"></div>
    <div v-if="records.length === 0" class="empty-record">ยังไม่มีข้อมูล</div>
    <div v-for="(record, idx) in records" :key="idx" class="record">
      <input
        class="record-value year text-color-primary"
        v-if="isEnableYear"
        type="number"
        v-model="record.year"
        placeholder="2025"
      />
      <div class="record-group">
        <div class="record-value text">
          <span v-if="isEnableEn" class="flag">TH</span>
          <input
            class="text-color-primary"
            type="text"
            v-model="record.text"
            :placeholder="placeholder || placeholderTh"
          />
        </div>
        <div class="record-value text" v-if="isEnableEn">
          <span class="flag">EN</span>
          <input class="text-color-primary" type="text" v-model="record.textEn" :placeholder="placeholderEn" />
        </div>
      </div>
      <div class="clear-container">
        <v-icon color="red" @click="() => deleteRecord(idx)">clear</v-icon>
      </div>
    </div>
    <div class="top-space-micro">
      <v-btn color="primary" @click="addRecord">Add</v-btn>
    </div>
    <pre v-if="isDebug">{{ records }}</pre>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    placeholderTh: {
      type: String,
      default: 'กรอกข้อมูลภาษาไทย',
    },
    placeholderEn: {
      type: String,
      default: 'Fill in English text',
    },
    isEnableYear: {
      type: Boolean,
      default: true,
    },
    isEnableEn: {
      type: Boolean,
      default: true,
    },
    isDebug: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      records: this.value,
    };
  },
  methods: {
    addRecord(e) {
      e.preventDefault();
      this.records.push({
        text: '',
        textEn: '',
        year: '',
      });
      this.$emit('input', this.records);
    },
    deleteRecord(idx) {
      this.records.splice(idx, 1);
      this.$emit('input', this.records);
    },
  },
};
</script>

<style scoped>
.provider-info-list-input {
  border: 1px solid #818181;
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 24px;
}

pre {
  background-color: #f5f5f5;
  padding: 16px;
  overflow-x: auto;
  margin-top: 16px;
}

.empty-record {
  font-style: italic;
  color: #888;
  padding-bottom: 8px;
}

.record {
  display: flex;
  align-items: stretch;
  margin-bottom: 8px;
}

input.record-value {
  text-align: center;
  width: 100%;
}

.record-group {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.record-value {
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-right: 8px;
}

input {
  border: none;
  padding: 2px 0px;
  margin: 0;
  width: 100%;
}

.flag {
  margin-right: 8px;
  font-size: 0.8rem;
  border-right: 1px solid #dbdbdb;
  padding-right: 8px;
}

.record-value.year {
  width: 100px;
  margin-right: 8px;
  justify-content: center;
  appearance: none;
}

.record-value input:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

input.record-value::-webkit-outer-spin-button,
input.record-value::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.record-value.text {
  flex-grow: 1;
}

.material-icons {
  cursor: pointer;
}

.clear-container {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
}

input.year {
  width: 100px;
  margin-right: 8px;
}

input.text {
  flex-grow: 1;
}

.subtitle {
  color: #666;
  font-size: 0.9rem;
}
</style>
